export default __webpack_public_path__ + "static/media/Camel.d5a4f258.jpg";